export default __webpack_public_path__ + "static/media/image3.293129d0.webp";